import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TractorProvider } from '../../_models/machinaries/tractorProvider';
import { Equipment } from '../../_models';

@Injectable()
export class MachineEquipmentService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}
  getEquipmentFromProviderList(
    equipment: Equipment,
    externalSource: string,
    externalId?: any
  ): Observable<TractorProvider[]> {
    return this.http
      .get<TractorProvider[]>(
        this.apiBaseUrl + 'api/private/v1/equipmentTelemetry/getListEquipmentFromProvider',
        {
          params: {
            externalSource,
            externalId,
            equipmentId: equipment.id,
          },
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
